import { gql } from '@apollo/client'

export const GET_DISPLAY = gql`
  query GetDisplay($id: ID!) {
    display(id: $id) {
      id
      name
      store {
        location {
          name
        }
      }
      planogram {
        shapedUpcs
      }
    }
  }
`
